import React from "react";
import type { TextWidget } from "../types";
import style from "./textResult.module.css";

export function TextResult({ widgetData }: { widgetData: TextWidget }) {
    return (
        <div className={style.textWrapper}>
            <p>{widgetData.text}</p>
        </div>
    );
}
